<template>
    <el-card class="page_card account_center" ref="card" v-loading="!is_ok">
        <el-tabs tab-position="left" style="height: 100%;">
            <el-tab-pane label="基本信息" style="padding: 20px 15px;overflow-y: auto;height: calc(100vh - 110px)">
                <el-form ref="dataForm" :model="data" :rules="rules" label-width="180px" class="demo-form-inline">
                    <el-row>
                        <span style="font-size: 1.2em">基本信息</span>
                        <el-divider></el-divider>
                        <el-col :span="10">
                            <el-form-item label="头像:">
                                <div>
                                    <el-avatar v-if="avatar_review.length == 0" :size="50" icon="el-icon-user-solid"></el-avatar>
                                    <el-avatar v-else :size="50" :src="avatar_review" fit="contain"></el-avatar>
                                </div>
                                <input type="file" name="file" style="display:none;" ref="upload_file" @change="file_change($event)">
                                <el-tooltip class="item" popper-class="upload_topic" effect="light" content="只能上传png,jpeg,jpg,gif格式的图片,最大1MB!" placement="right">
                                    <el-button type="primary" size="mini" plain @click="selectImg()" :loading="is_upload" :disabled="is_post">{{is_upload?'上传中...':'更新头像'}}</el-button>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item label="登录名:">
                                <el-input disabled v-model="data.username" placeholder="登录名"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名:" prop="name">
                                <el-input v-model="data.name" placeholder="姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号:" prop="mobile">
                                <el-input v-model="data.mobile" placeholder="手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱:" prop="email">
                                <el-input v-model="data.email" placeholder="邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="职务:">
                                <el-input v-model="data.jobName" placeholder="职务" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="上次登录IP:">
                                <span class="primary_text">{{userinfo.lastIp}}</span>
                            </el-form-item>
                            <el-form-item label="上次登录时间:">
                                <span class="primary_text">{{formatTime(userinfo.lastLogin)}}</span>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="warning" plain @click="editSubmit()" :loading="is_post">更新基本信息</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="安全信息" style="padding: 20px 15px">
                <el-form :model="editPwd" ref="pwdForm" :rules="pwdRules" label-width="180px" class="demo-form-inline">
                    <el-row>
                        <span style="font-size: 1.2em">安全信息</span>
                        <el-divider></el-divider>
                        <el-col :span="10">
                            <el-form-item label="账户密码:" prop="oldPassword">
                                <el-input placeholder="请输入原密码" type="password" v-model="editPwd.oldPassword"></el-input>
                            </el-form-item>
                            <el-form-item label="新密码:" prop="newPassword">
                                <el-input placeholder="请输入新密码" type="password" @blur="pwdchange()" v-model="editPwd.newPassword"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码:" prop="newPassword1">
                                <el-input placeholder="请再次输入密码" type="password" @blur="pwdchange()" v-model="editPwd.newPassword1"></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="warning" plain :loading="is_post" @click="changePwd">修改密码</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import {mapGetters} from 'vuex'
import request from "@/utils/request"
import {formatTime} from "@/utils/index"
import { validEmail } from '@/utils/elvalid'
export default {
    name: 'account_basic',
    computed:{
        ...mapGetters([
            'userinfo'
        ])
    },
    data(){
        let validqrpwd = (rule, value, callback)=>{
            if(value){
                if(value != this.editPwd.newPassword){
                    callback(new Error("两次密码不同"));
                }else{
                    callback();
                }
            }else{
                callback(new Error("请填写确认密码"));
            }
        }
        return {
            is_ok:true,
            data:{
                username:"",
                name:"",
                email:"",
                mobile:"",
                jobName:"",
                avatar:""
            },
            editPwd:{
                oldPassword:"",
                newPassword:"",
                newPassword1:""
            },
            rules:{
                password:[
                    { required: true, message: '请填写密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                ],
                name:[
                    { required: true, message: '请填写用户姓名', trigger: 'blur' },
                    { min: 0, max: 10, message: '姓名不超过10位字符', trigger: 'blur' }
                ],
                mobile:[
                    { required: true, message: '请填写手机号', trigger: 'blur' },
                    { pattern:/^1[345789]\d{9}$/, message: '请填写正确的手机号', trigger: 'blur' }
                ],
                email:[
                    { validator: validEmail, trigger: 'blur' }
                ],
            },
            pwdRules:{
                oldPassword:[
                    { required: true, message: '请填写原密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                ],
                newPassword:[
                    { required: true, message: '请填写新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                ],
                newPassword1:[
                    { required: true, message: '请填写确认密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' },
                    { validator:validqrpwd, trigger: 'blur' }
                ]
            },
            is_post:false,
            is_upload:false,
            avatar_review:""
        }
    },
    methods:{
        init(){
            for(let k of Object.keys(this.userinfo)){
                if(["username","name","email","mobile","jobName","avatar"].includes(k)){
                    this.data[k] = this.userinfo[k];
                }
            }
            this.avatar_review = this.userinfo.avatar;
        },
        editSubmit(){
            this.$refs["dataForm"].validate(valid=>{
                if(!valid)return false;
                this.is_post = true;
                request.post("account/edit_info",this.data).then(res=>{
                    this.$message.success("修改资料成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        //文件改动
        file_change(e){
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (event)=>{
                this.avatar_review = event.target.result;
            };
            reader.readAsDataURL(file);
            this.is_upload = true;
            this.$store.dispatch("upload/uploadImg",{file:file}).then(res=>{
                this.is_upload = false;
                this.avatar_review = res.url;
                this.data.avatar = res.url;
            }).catch(err=>{
                this.is_upload = false;
                console.log(err);
                this.$message.warning(err.msg);
            });
        },
        //选择图片
        selectImg(){
            this.$refs["upload_file"].click();
        },
        pwdchange(){
            this.$refs["pwdForm"].validateField("qr_pwd",(valid)=>{});
        },
        changePwd(){
            this.$refs["pwdForm"].validate(valid=>{
                if(!valid)return false;
                this.is_post = true;
                request.post("account/change_pwd",this.editPwd).then(res=>{
                    this.$message.success("您的密码已修改");
                    this.$refs["pwdForm"].resetFields();
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            })
        },
        formatTime(time){
            return formatTime(time);
        }
    },
    created(){
        this.init();
    }
}
</script>

<style scoped lang="scss">

</style>
